import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      // Show consent popup after a short delay
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
    } catch (error) {
      console.warn('Could not save cookie consent to localStorage:', error);
    }
    setShowConsent(false);
  };

  const handleDecline = () => {
    try {
      localStorage.setItem('cookieConsent', 'declined');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
    } catch (error) {
      console.warn('Could not save cookie consent to localStorage:', error);
    }
    setShowConsent(false);
  };

  const handleDetails = () => {
    setShowDetails(!showDetails);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <>
      <div className="cookie-consent" role="dialog" aria-label="Cookie notice">
        <div className="cookie-consent-content">
          <div className="cookie-consent-header">
            <h3>Cookie notice</h3>
            <button
              className="cookie-consent-close"
              onClick={handleDecline}
              aria-label="Close cookie consent"
            >
              <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path
                  d="M1 1l10 10M11 1L1 11"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          <div className="cookie-consent-body">
            <p>
              We use cookies to enhance your browsing experience, serve personalized content, 
              and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
            </p>
            
            {showDetails && (
              <div className="cookie-consent-details">
                <h4>Types of cookies we use:</h4>
                <ul>
                  <li><strong>Essential cookies:</strong> Required for the website to function properly</li>
                  <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with our website</li>
                  <li><strong>Functional cookies:</strong> Remember your preferences and settings</li>
                  <li><strong>Marketing cookies:</strong> Used to deliver relevant advertisements</li>
                </ul>
                <p>
                  You can learn more about how we use cookies in our{' '}
                  <Link to="/privacy" onClick={handleDecline}>Privacy Policy</Link>.
                </p>
              </div>
            )}
          </div>

          <div className="cookie-consent-actions">
            <button className="btn btn--link btn--sm" onClick={handleDetails}>
              {showDetails ? 'Hide details' : 'Learn more'}
            </button>
            <div className="cookie-consent-primary-actions">
              <button className="btn btn--ghost btn--sm" onClick={handleDecline}>
                Decline
              </button>
              <button className="btn btn--primary btn--sm" onClick={handleAccept}>
                Accept all
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
